/* eslint-disable */

export function wrapRootElement({ element }) {
  return element;
}
